import { createRef, h } from 'preact';
import { accessible } from 'utilities/accessibility';
import { APPLICATION_EVENT } from 'constants/events';
import { LANGUAGE } from 'constants/context';
import { isoCodeToName } from '../../../constants/iso_languages';
import elementClosestPolyfill from 'element-closest';
import {ControlsMenu} from "./ControlsMenu";
import './language.scss';

elementClosestPolyfill(window);

const ENGLISH = 'en';

class Language extends ControlsMenu {
    changeOption = (language, event) => {
        this.allowOverflow(event.target, false);
        this.eventBus.emit(APPLICATION_EVENT.SET_STATE, LANGUAGE, language);
    };

    get availableLanguages() {
        const { projectData = {} } = this.props;
        const { languages = [] } = projectData;
        return languages;
    }

    get activeOption() {
        const { projectState = {} } = this.props;
        const { language = '' } = projectState;
        return language;
    }

    get menuItems() {
        const languages = [...this.availableLanguages];

        if (!languages.includes(ENGLISH)) {
            languages.unshift(ENGLISH);
        }

        return languages;
    }

    formatOption = text => {
        return isoCodeToName(text);
    }

    get menuIsActive() {
        const { menus = {} } = this.props;
        const { showLanguageMenu } = menus;
        return showLanguageMenu;
    }

    get menuButtonText() {
        const { projectState } = this.props; 
        const { language = "en" } = projectState; 

        return language.toUpperCase();
    }

    render () {
        if (this.availableLanguages.length === 0) return null;

        const attrs = {
            name: 'language',
            onClick: this.toggleMenu,
            className: 'language controlBarButton vjs-control vjs-button',
            title: 'Language Selector',
            ['aria-haspopup']: true,
            ...accessible(this.toggleMenu)
        }

        return (
            /* need to use div instead of button due to IE event capture limitations 😠 */
            <div {...attrs}>
                {this.menuButton}
                {this.menu}
            </div>
        )
    }
}

export {Language};
